import React from "react";
import { useTranslation } from "react-i18next";

import { PickupRequestListItem } from "../../../../types";

import TwoLineGridCell from "../TwoLineGridCell";

interface Props {
  data: PickupRequestListItem;
}

const ParticipantsGridCell = ({ data }: Props) => {
  const { t } = useTranslation();

  const collectorName = data.sourceCompanyRegNumber
    ? `${data.sourceCompanyName} (${data.sourceCompanyRegNumber})`
    : data.sourceCompanyName;

  return (
    <TwoLineGridCell
      firstLineData={collectorName}
      secondLineData={
        data.targetCompanyName || t("pickupRequests.grid.awaitingAssignment")
      }
    />
  );
};

export default ParticipantsGridCell;
